import { BookOpen, Camera, CookingPot, FileDown, Lightbulb, Scale, Thermometer, Timer } from "lucide-react";
import type { Faq, Review } from "../types/product";

// Recensioni: sostituisci con foto, testi e nomi autentici delle clienti.
// Lascia "photo" vuoto per mostrare lo spazio da compilare.
export const reviews: Review[] = [
  { photo: undefined, quote: "[Inserisci qui il testo autentico della recensione della cliente]", name: "[Nome C.]", rating: 5 },
  { photo: undefined, quote: "[Inserisci qui il testo autentico della recensione della cliente]", name: "[Nome C.]", rating: 5 },
  { photo: undefined, quote: "[Inserisci qui il testo autentico della recensione della cliente]", name: "[Nome C.]", rating: 5 },
  { photo: undefined, quote: "[Inserisci qui il testo autentico della recensione della cliente]", name: "[Nome C.]", rating: 5 },
  { photo: undefined, quote: "[Inserisci qui il testo autentico della recensione della cliente]", name: "[Nome C.]", rating: 5 },
  { photo: undefined, quote: "[Inserisci qui il testo autentico della recensione della cliente]", name: "[Nome C.]", rating: 5 },
  { photo: undefined, quote: "[Inserisci qui il testo autentico della recensione della cliente]", name: "[Nome C.]", rating: 5 },
];

export const insideFeatures = [
  { icon: Camera, label: "Foto del prodotto finito" },
  { icon: Scale, label: "Ingredienti e dosi precise" },
  { icon: Thermometer, label: "Metodo passo passo con temperature e tempi" },
  { icon: Timer, label: "Dimensione del lotto, durata e costo per lotto" },
  { icon: Lightbulb, label: "Consigli per risultati migliori e controlli di qualità" },
];

export const insideCallouts = [
  { label: "Foto HD del prodotto", position: "right-3 top-4 sm:right-6 sm:top-8" },
  { label: "Dosi esatte", position: "left-3 top-[38%] sm:left-6" },
  { label: "Metodo passo dopo passo", position: "left-3 bottom-[22%] sm:left-6" },
];

export const steps = [
  {
    icon: FileDown,
    title: "Scarica subito",
    body: "Appena paghi, tutti e sei i PDF e i 5 bonus arrivano nella tua email. Nessuna app, nessun login, niente da aspettare.",
  },
  {
    icon: BookOpen,
    title: "Scegli la tua ricetta",
    body: "Apri la collezione che preferisci e scegli una ricetta. Ognuna ti dice quanto costa farla prima ancora di comprare un solo ingrediente.",
  },
  {
    icon: CookingPot,
    title: "Inizia a fare",
    body: "Segui grammi e temperature, poi stampa l'etichetta INCI che trovi con la ricetta e incollala sul vasetto.",
  },
];

export const faqs: Faq[] = [
  {
    question: "Non ho mai fatto nulla del genere. Fa per me?",
    answer: "Sì: le ricette sono scritte per chi parte da zero, con grammi e temperature esatte. Inizia con un burro o uno scrub da 4 ingredienti.",
  },
  {
    question: "Ci sono 600+ ricette. Da dove inizio?",
    answer: "Da quella che useresti domani. Apri Il Metodo Belnestore e prepara un burro corpo o uno scrub.",
  },
  {
    question: "Serve un'attrezzatura speciale?",
    answer: "Una bilancia digitale da cucina, una ciotola, una pentola e una spatola.",
  },
  {
    question: "Dove compro gli ingredienti?",
    answer: "Molti li hai già in cucina (olio di cocco, zucchero, avena, miele); il resto online o in erboristeria. Il Metodo Belnestore spiega cosa comprare.",
  },
  {
    question: "Quanto tempo richiede una ricetta?",
    answer: "Di solito 15–30 minuti; scrub e oli circa 10. Quello che richiede tempo è il raffreddamento.",
  },
  {
    question: "Quanto dura quello che preparo?",
    answer: "Ogni ricetta indica la sua durata, accanto agli ingredienti.",
  },
  {
    question: "Riceverò qualcosa per posta?",
    answer: "No, è tutto digitale.",
  },
  {
    question: "Come ricevo i file?",
    answer: "Un link nella tua email appena paghi; puoi riscaricarli quando vuoi.",
  },
  {
    question: "Funziona su telefono o tablet?",
    answer: "Sì, sono PDF; molte persone tengono la ricetta aperta sul telefono mentre la preparano.",
  },
  {
    question: "Devo stampare qualcosa?",
    answer: "No; ogni ricetta è una sola pagina, quindi se vuoi stampi un foglio.",
  },
  {
    question: "Posso vendere quello che preparo?",
    answer: "Sì: due bonus sono pensati per questo (prezzo, etichette, lotto e PAO). Non puoi rivendere i file.",
  },
  {
    question: "È un pagamento unico?",
    answer: "Sì, nessun abbonamento.",
  },
];
